import { Block } from "@components/block";
import { ExpandableText } from "@components/expandableText/ExpandableText";
import { FilterConfig } from "@components/filter-modal";
import { Config, Table } from "@components/table";
import { useNotifications } from "@features/notification";
import { Notification, NotificationForm } from "@features/notification/api";
import { formatDate, formatTime } from "@helpers/date";
import { formatUsdt } from "@helpers/format";
import { usePagination } from "@hooks/use-pagination";
import { useUrlFilters } from "@hooks/useUrlFilters";
import { useWebSocket } from "@request/useWebsocket";
import { WebsocketUpdateType } from "@request/websocket";
import { useEffect } from "react";

const messageToUpdate = [WebsocketUpdateType.Notification, WebsocketUpdateType.Withdrawal, WebsocketUpdateType.Appeal]
const config: Config<Notification> = [
  {
    label: "Тип операции",
    source: "message",
    renderComponent: (data) => (
      <ExpandableText text={data} maxLines={2} lineHeightEm={1.5} />
    ),
  },
  {
    label: "Время",
    source: "created_at",
    renderComponent: (dateTime) => formatTime(new Date(dateTime)),
  },
  {
    label: "Дата",
    source: "created_at",
    renderComponent: (dateTime) => formatDate(new Date(dateTime)),
  },
  {
    label: "Сумма",
    source: "money",
    renderComponent: (money) => money && formatUsdt(money),
  },
];

export const Operations = () => {
  const { getNotifications, state } = useNotifications();
  const { page, limit, setPage, setLimit } = usePagination();
  const { setParams } = useUrlFilters();
  const { lastMessage } = useWebSocket();

  useEffect(() => {
    if (lastMessage && messageToUpdate.includes(lastMessage.type)) {
      getNotifications({ page, limit, has_money: true });
    }
  }, [lastMessage, limit, page]);

  useEffect(() => {
    getNotifications({ page, limit, has_money: true });
  }, [getNotifications, limit, page]);

  const filterConfig: FilterConfig<NotificationForm> = [
    {
      type: "select",
      options: [
        { text: "Пополнение баланса", value: "transfer" },
        { text: "Споры", value: "appeal" },
      ],
      label: "Тип уведомления",
      placeholder: "Тип уведомления",
      // defaultValue?: string,
      name: "event_type",
    },
    {
      type: "date",
      withTime: true,
      nameStart: "start_date",
      nameEnd: "end_date",
      returnValue: "string",
    },
  ];
  const onSubmit = (data: NotificationForm) => {
    data.has_money = true;
    setParams(data);
    getNotifications(data);
  };

  return (
    <Block>
      <Table
        title="История операций"
        placeholder="Поиск по операциям"
        withFilter
        filterProps={{
          filterConfig: filterConfig,
          onSubmit: onSubmit,
        }}
        config={config}
        data={state.notifications}
        setPage={setPage}
        setLimit={setLimit}
        page={page}
        limit={limit}
        totalCount={state.totalCount}
      />
    </Block>
  );
};
